module.exports = __webpack_public_path__ + "img/735bcca8ae3f8e456f49a23c9999c192.png";